export const APP_ROUTER_FUTURE = Object.freeze({
    v7_startTransition: true
});
